import { memo } from 'react';
import { Label } from 'semantic-ui-react';
import { ImportDescriptorIdType } from '../../../../../../types';
import {
    useImportTableStoreDescriptorSupportsSignFlip,
    useImportTableStoreReportActions,
} from '../../../../context/importTableContext';

type SingFlipCellPropsType = {
    descriptorId: ImportDescriptorIdType;
    onClick?: () => void;
};
const SingFlipCell = memo(function SingFlipCell({ descriptorId, onClick = () => {} }: SingFlipCellPropsType) {
    const isSignFlipSupported = useImportTableStoreDescriptorSupportsSignFlip(descriptorId);
    const { inverseReportsFieldValues } = useImportTableStoreReportActions();
    return (
        <td>
            {isSignFlipSupported && (
                <Label
                    className="import-table__label cursor-pointer"
                    onClick={() => {
                        inverseReportsFieldValues(descriptorId);
                        onClick();
                    }}
                    size="mini"
                >
                    FLIP
                </Label>
            )}
        </td>
    );
});

export default SingFlipCell;
